<section class="headline">
  <h3>Dashboard</h3>
  <p>Manage admin components throughout this website.</p>
</section>

<div class="cards">
  <ng-container *ngIf="adminPages.length; else empty">
    <mat-card class="card mat-elevation-z1" *ngFor="let page of adminPages" [routerLink]="page.routerLink">
      <mat-card-content>
        <mat-card-title>{{page.name}}</mat-card-title>
        <mat-card-subtitle>{{page.description}}</mat-card-subtitle>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-template #empty>
    <div class="card">
      <h2 class="word-wrap">No admin pages yet!</h2>
      <p class="word-wrap">Start coding some cool stuff!</p>
    </div>
  </ng-template>
</div>
